/* Favoritos fundasdesofa — localStorage, sin apps externas */
(function () {
  var KEY = 'fds_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.style.display = list.length ? '' : 'none';
    });
    syncPage();
  }

  /* Estado de la PAGINA de favoritos: recuento, aviso y estado vacio.
     Los tres se derivan de lo que hay REALMENTE PINTADO, no de lo guardado, porque no
     coinciden siempre: si una peticion ?view=card falla, la pieza sigue en localStorage
     pero no hay tarjeta. Contando lo guardado la pagina decia "3 piezas guardadas"
     sobre una rejilla vacia, sin explicar nada.
     Los badges del header y del drawer NO pasan por aqui: siguen contando lo guardado,
     que es lo correcto para ellos.
     El sufijo sale de data-suffix-one / data-suffix-other y los mensajes de
     data-msg-all / data-msg-some, todos resueltos por Liquid: aqui no hay texto. */
  function syncPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    var saved = read().length;
    /* Mientras las peticiones no han asentado no se puede hablar de lo pintado, asi que
       el recuento provisional es lo guardado: es un estado de carga, no una afirmacion. */
    var settled = grid.hasAttribute('data-wishlist-settled');
    var shown = settled ? grid.querySelectorAll('[data-wishlist-cell]').length : saved;

    document.querySelectorAll('[data-wishlist-count-label]').forEach(function (label) {
      label.style.display = shown ? '' : 'none';
      var total = label.querySelector('[data-wishlist-total]');
      if (total) total.textContent = shown;
      var suffix = label.querySelector('[data-wishlist-count-suffix]');
      /* CLDR: en es y en en la forma "one" es exactamente 1; el 0 va con "other". */
      if (suffix) suffix.textContent = label.getAttribute(shown === 1 ? 'data-suffix-one' : 'data-suffix-other') || '';
    });

    /* El estado vacio afirma "todavia no has guardado ninguna pieza". Eso solo es verdad
       si NO hay nada guardado; con piezas guardadas que no se han podido cargar seria
       mentira, y es justo el vacio enganoso que hay que evitar. */
    var empty = document.querySelector('[data-wishlist-empty]');
    if (empty) empty.style.display = saved === 0 ? '' : 'none';

    var notice = document.querySelector('[data-wishlist-notice]');
    if (!notice) return;
    var msg = '';
    if (settled && saved > 0 && shown === 0) msg = notice.getAttribute('data-msg-all') || '';
    else if (settled && shown < saved) msg = notice.getAttribute('data-msg-some') || '';
    /* Solo se escribe si cambia: reescribir el mismo texto vuelve a disparar el anuncio
       de la region role="status" en cada repintado. */
    if (notice.textContent !== msg) notice.textContent = msg;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-handle'));
    paint();
  });

  document.addEventListener('wishlist:change', paint);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();

  /* Página de favoritos: pinta las mismas tarjetas que colecciones (product-card vía ?view=card) */
  var grid = document.querySelector('[data-wishlist-grid]');
  if (grid) {
    /* El oyente se registra AHORA, antes de pedir nada. Registrandolo dentro del .then se
       perdian los cambios ocurridos MIENTRAS las peticiones estaban en vuelo: la pieza
       quitada no tenia todavia celda que borrar, el evento pasaba sin oyente, y luego se
       insertaba igual desde la lista inicial. La pagina acababa contando mas piezas de las
       guardadas y con una celda que ya nadie iba a quitar. */
    document.addEventListener('wishlist:change', function () {
      var l = read();
      /* Se quita la CELDA, no solo la tarjeta: dejar la celda vacia mantendria un
         listitem fantasma en el recuento de la lista. El handle se lee de la celda, que
         lo lleva propio: no depende de encontrar el boton dentro. */
      grid.querySelectorAll('[data-wishlist-cell]').forEach(function (cell) {
        var h = cell.getAttribute('data-handle');
        if (h && l.indexOf(h) === -1) cell.remove();
      });
      /* paint() -y con el syncPage- ya corrio al despacharse el evento, con las celdas
         TODAVIA en el DOM, porque su listener se registro antes que este. Asi que hay que
         volver a sincronizar DESPUES de quitarlas o el recuento se queda una pieza alto. */
      syncPage();
    });

    var favs = read();
    if (!favs.length) {
      /* Nada que pedir: ya esta asentado, y syncPage decide el estado vacio. */
      grid.setAttribute('data-wishlist-settled', '');
      syncPage();
      return;
    }
    /* Promise.resolve().then(...) para que un fallo SINCRONO de fetch (no existe, lanza al
       llamarlo) se convierta en rechazo y lo recoja el catch: si se escapa, el map revienta
       y la pagina nunca llega a asentar. */
    Promise.all(favs.map(function (handle) {
      return Promise.resolve()
        .then(function () { return fetch('/products/' + handle + '?view=card'); })
        .then(function (r) { return r && r.ok ? r.text() : null; })
        .catch(function () { return null; })
        /* El handle viaja PEGADO a su respuesta. Sin el no hay forma de saber a que pieza
           corresponde una respuesta que llega tarde. */
        .then(function (html) { return { handle: handle, html: html }; });
    })).then(function (respuestas) {
      /* Se relee la lista AQUI, no se reutiliza favs: entre la peticion y la respuesta el
         cliente ha podido quitar piezas, y una respuesta tardia no debe revivir su celda. */
      var vigentes = read();
      respuestas.forEach(function (r) {
        if (!r.html) return;
        if (vigentes.indexOf(r.handle) === -1) return;
        /* El contenedor declara role="list", asi que cada tarjeta necesita su listitem:
           una lista ARIA cuyos hijos no lo son se anuncia vacia. La tarjeta se reutiliza
           tal cual (product-card via ?view=card) y la semantica va en la celda. */
        var cell = document.createElement('div');
        cell.className = 'wl-cell';
        cell.setAttribute('role', 'listitem');
        cell.setAttribute('data-wishlist-cell', '');
        cell.setAttribute('data-handle', r.handle);
        cell.innerHTML = r.html;
        grid.appendChild(cell);
      });
      /* Asentado: desde aqui el recuento de la pagina y el aviso ya pueden hablar de lo
         pintado. Se marca ANTES de sincronizar, que es lo que lo hace verdad. */
      grid.setAttribute('data-wishlist-settled', '');
      paint();
    })
      /* Fallo total del conjunto: igual hay que asentar, o la pagina se queda contando
         piezas guardadas que no ha pintado y sin decir por que. */
      .catch(function () {
        grid.setAttribute('data-wishlist-settled', '');
        syncPage();
      });
  }
})();
